import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink } from "react-router-dom";
import AddWorkForm from "../Components/Work/AddWorkForm";

const NewWork = () => {
  return (
    <Box
      sx={{
        p: 3,
        maxWidth: 1200,
        margin: "0 auto",
        height: "calc(100vh - 64px)",
        overflow: "hidden",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <Button
          component={RouterLink}
          to="/resources"
          startIcon={<ArrowBackIcon />}
          sx={{ mb: 2, color: "#3598b7" }}
        >
          Resources
        </Button>
        <Typography variant="h4" sx={{ mb: 1, color: "#3598b7", fontWeight: 600 }}>
          Add Motion Air work
        </Typography>
        <Typography sx={{ mb: 3, color: "rgba(46, 46, 46, 0.75)" }}>
          Use Save draft for a shared team draft, or upload a video and it is
          saved automatically. Publish project merges that page into the website.
        </Typography>
      </Box>
      <AddWorkForm />
    </Box>
  );
};

export default NewWork;
